/**
 * @generated SignedSource<<3adc3d233d430798c0f1abf1b1499052>>
 * @relayHash 628a56ca33e9462b0d28ee38c9055b21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83b376ae5628ba7b036093c628acc4c9bcbbfa4d904bbfabdb1d1199730710a7

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useNewUserTemplatesGetMultipleTemplateInfoQuery$variables = {
  templateId0: string;
  templateId1: string;
  templateId2: string;
};
export type useNewUserTemplatesGetMultipleTemplateInfoQuery$data = {
  readonly template0: {
    readonly author: string | null | undefined;
    readonly blueprintModuleCompleteKey: string | null | undefined;
    readonly categoryIds: ReadonlyArray<string | null | undefined>;
    readonly contentBlueprintId: string | null | undefined;
    readonly darkModeIconURL: string | null | undefined;
    readonly description: string | null | undefined;
    readonly hasGlobalBlueprintContent: boolean;
    readonly hasWizard: boolean | null | undefined;
    readonly iconURL: string | null | undefined;
    readonly isFavourite: boolean | null | undefined;
    readonly isNew: boolean | null | undefined;
    readonly isPromoted: boolean | null | undefined;
    readonly itemModuleCompleteKey: string | null | undefined;
    readonly keywords: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly name: string | null | undefined;
    readonly recommendationRank: number | null | undefined;
    readonly styleClass: string | null | undefined;
    readonly templateId: string | null | undefined;
    readonly templateType: string | null | undefined;
  } | null | undefined;
  readonly template1: {
    readonly author: string | null | undefined;
    readonly blueprintModuleCompleteKey: string | null | undefined;
    readonly categoryIds: ReadonlyArray<string | null | undefined>;
    readonly contentBlueprintId: string | null | undefined;
    readonly darkModeIconURL: string | null | undefined;
    readonly description: string | null | undefined;
    readonly hasGlobalBlueprintContent: boolean;
    readonly hasWizard: boolean | null | undefined;
    readonly iconURL: string | null | undefined;
    readonly isFavourite: boolean | null | undefined;
    readonly isNew: boolean | null | undefined;
    readonly isPromoted: boolean | null | undefined;
    readonly itemModuleCompleteKey: string | null | undefined;
    readonly keywords: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly name: string | null | undefined;
    readonly recommendationRank: number | null | undefined;
    readonly styleClass: string | null | undefined;
    readonly templateId: string | null | undefined;
    readonly templateType: string | null | undefined;
  } | null | undefined;
  readonly template2: {
    readonly author: string | null | undefined;
    readonly blueprintModuleCompleteKey: string | null | undefined;
    readonly categoryIds: ReadonlyArray<string | null | undefined>;
    readonly contentBlueprintId: string | null | undefined;
    readonly darkModeIconURL: string | null | undefined;
    readonly description: string | null | undefined;
    readonly hasGlobalBlueprintContent: boolean;
    readonly hasWizard: boolean | null | undefined;
    readonly iconURL: string | null | undefined;
    readonly isFavourite: boolean | null | undefined;
    readonly isNew: boolean | null | undefined;
    readonly isPromoted: boolean | null | undefined;
    readonly itemModuleCompleteKey: string | null | undefined;
    readonly keywords: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly name: string | null | undefined;
    readonly recommendationRank: number | null | undefined;
    readonly styleClass: string | null | undefined;
    readonly templateId: string | null | undefined;
    readonly templateType: string | null | undefined;
  } | null | undefined;
};
export type useNewUserTemplatesGetMultipleTemplateInfoQuery = {
  response: useNewUserTemplatesGetMultipleTemplateInfoQuery$data;
  variables: useNewUserTemplatesGetMultipleTemplateInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId0"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId1"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId2"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "templateId"
  },
  {
    "kind": "ScalarField",
    "name": "contentBlueprintId"
  },
  {
    "kind": "ScalarField",
    "name": "blueprintModuleCompleteKey"
  },
  {
    "kind": "ScalarField",
    "name": "itemModuleCompleteKey"
  },
  {
    "kind": "ScalarField",
    "name": "templateType"
  },
  {
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "kind": "ScalarField",
    "name": "description"
  },
  {
    "kind": "ScalarField",
    "name": "iconURL"
  },
  {
    "kind": "ScalarField",
    "name": "darkModeIconURL"
  },
  {
    "kind": "ScalarField",
    "name": "styleClass"
  },
  {
    "kind": "ScalarField",
    "name": "hasWizard"
  },
  {
    "kind": "ScalarField",
    "name": "isNew"
  },
  {
    "kind": "ScalarField",
    "name": "isPromoted"
  },
  {
    "kind": "ScalarField",
    "name": "isFavourite"
  },
  {
    "kind": "ScalarField",
    "name": "hasGlobalBlueprintContent"
  },
  {
    "kind": "ScalarField",
    "name": "categoryIds"
  },
  {
    "kind": "ScalarField",
    "name": "keywords"
  },
  {
    "kind": "ScalarField",
    "name": "recommendationRank"
  },
  {
    "kind": "ScalarField",
    "name": "author"
  }
],
v2 = [
  {
    "alias": "template0",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "templateId0"
      }
    ],
    "concreteType": "TemplateInfo",
    "kind": "LinkedField",
    "name": "templateInfo",
    "plural": false,
    "selections": (v1/*: any*/)
  },
  {
    "alias": "template1",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "templateId1"
      }
    ],
    "concreteType": "TemplateInfo",
    "kind": "LinkedField",
    "name": "templateInfo",
    "plural": false,
    "selections": (v1/*: any*/)
  },
  {
    "alias": "template2",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "templateId2"
      }
    ],
    "concreteType": "TemplateInfo",
    "kind": "LinkedField",
    "name": "templateInfo",
    "plural": false,
    "selections": (v1/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useNewUserTemplatesGetMultipleTemplateInfoQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useNewUserTemplatesGetMultipleTemplateInfoQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "628a56ca33e9462b0d28ee38c9055b21",
    "id": "83b376ae5628ba7b036093c628acc4c9bcbbfa4d904bbfabdb1d1199730710a7",
    "metadata": {},
    "name": "useNewUserTemplatesGetMultipleTemplateInfoQuery",
    "operationKind": "query",
    "text": "query useNewUserTemplatesGetMultipleTemplateInfoQuery($templateId0:ID!,$templateId1:ID!,$templateId2:ID!){template0:templateInfo(id:$templateId0){templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author},template1:templateInfo(id:$templateId1){templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author},template2:templateInfo(id:$templateId2){templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author}}"
  }
};
})();

(node as any).hash = "f2f7112db65307812c35e5adf447d1ca";

export default node;
